
<app-app-wrapper>
    <router-outlet></router-outlet>
</app-app-wrapper>
